// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file marketing_campaign.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file marketing_campaign.proto.
 */
export const file_marketing_campaign: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message grpc.api.v1.MarketingCampaign
 */
export type MarketingCampaign = Message<"grpc.api.v1.MarketingCampaign"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string locale = 2;
   */
  locale: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string subject = 4;
   */
  subject: string;

  /**
   * @generated from field: int64 contact_filter_id = 5;
   */
  contactFilterId: bigint;

  /**
   * @generated from field: string contact_filter_name = 6;
   */
  contactFilterName: string;

  /**
   * @generated from field: string contact_filter_data = 7;
   */
  contactFilterData: string;

  /**
   * @generated from field: string template_name = 8;
   */
  templateName: string;

  /**
   * @generated from field: string template_design = 9;
   */
  templateDesign: string;

  /**
   * @generated from field: string template_html = 10;
   */
  templateHtml: string;

  /**
   * @generated from field: string template_plaintext = 11;
   */
  templatePlaintext: string;

  /**
   * @generated from field: string template_preview = 12;
   */
  templatePreview: string;

  /**
   * @generated from field: string preview_text = 13;
   */
  previewText: string;

  /**
   * @generated from field: grpc.api.v1.MarketingCampaign.Status status = 14;
   */
  status: MarketingCampaign_Status;

  /**
   * @generated from field: int64 dt_create = 15;
   */
  dtCreate: bigint;

  /**
   * @generated from field: int64 dt_update = 16;
   */
  dtUpdate: bigint;

  /**
   * @generated from field: int64 dt_send = 17;
   */
  dtSend: bigint;

  /**
   * @generated from field: int64 dt_processed = 18;
   */
  dtProcessed: bigint;

  /**
   * @generated from field: bool is_archived = 19;
   */
  isArchived: boolean;

  /**
   * @generated from field: bool is_deleted = 20;
   */
  isDeleted: boolean;

  /**
   * @generated from field: grpc.api.v1.MarketingCampaign.AudienceStats audience_stats = 21;
   */
  audienceStats?: MarketingCampaign_AudienceStats | undefined;

  /**
   * @generated from field: grpc.api.v1.MarketingCampaign.PublishStats publish_stats = 22;
   */
  publishStats?: MarketingCampaign_PublishStats | undefined;

  /**
   * @generated from field: grpc.api.v1.MarketingCampaign.DeliveryStats delivery_stats = 23;
   */
  deliveryStats?: MarketingCampaign_DeliveryStats | undefined;

  /**
   * @generated from field: grpc.api.v1.MarketingCampaign.EngagementStats engagement_stats = 24;
   */
  engagementStats?: MarketingCampaign_EngagementStats | undefined;

  /**
   * @generated from field: grpc.api.v1.MarketingCampaign.ConversionStats conversion_stats = 25;
   */
  conversionStats?: MarketingCampaign_ConversionStats | undefined;
};

/**
 * Describes the message grpc.api.v1.MarketingCampaign.
 * Use `create(MarketingCampaignSchema)` to create a new message.
 */
export const MarketingCampaignSchema: GenMessage<MarketingCampaign> = /*@__PURE__*/
  messageDesc(file_marketing_campaign, 0);

/**
 * @generated from message grpc.api.v1.MarketingCampaign.AudienceStats
 */
export type MarketingCampaign_AudienceStats = Message<"grpc.api.v1.MarketingCampaign.AudienceStats"> & {
  /**
   * @generated from field: int64 all = 1;
   */
  all: bigint;

  /**
   * @generated from field: int64 matching = 2;
   */
  matching: bigint;
};

/**
 * Describes the message grpc.api.v1.MarketingCampaign.AudienceStats.
 * Use `create(MarketingCampaign_AudienceStatsSchema)` to create a new message.
 */
export const MarketingCampaign_AudienceStatsSchema: GenMessage<MarketingCampaign_AudienceStats> = /*@__PURE__*/
  messageDesc(file_marketing_campaign, 0, 0);

/**
 * @generated from message grpc.api.v1.MarketingCampaign.PublishStats
 */
export type MarketingCampaign_PublishStats = Message<"grpc.api.v1.MarketingCampaign.PublishStats"> & {
  /**
   * @generated from field: int64 all = 1;
   */
  all: bigint;

  /**
   * @generated from field: int64 scheduled = 2;
   */
  scheduled: bigint;

  /**
   * @generated from field: int64 sent = 3;
   */
  sent: bigint;

  /**
   * @generated from field: int64 processing = 4;
   */
  processing: bigint;

  /**
   * @generated from field: int64 abandoned = 5;
   */
  abandoned: bigint;

  /**
   * @generated from field: int64 failure = 6;
   */
  failure: bigint;
};

/**
 * Describes the message grpc.api.v1.MarketingCampaign.PublishStats.
 * Use `create(MarketingCampaign_PublishStatsSchema)` to create a new message.
 */
export const MarketingCampaign_PublishStatsSchema: GenMessage<MarketingCampaign_PublishStats> = /*@__PURE__*/
  messageDesc(file_marketing_campaign, 0, 1);

/**
 * @generated from message grpc.api.v1.MarketingCampaign.DeliveryStats
 */
export type MarketingCampaign_DeliveryStats = Message<"grpc.api.v1.MarketingCampaign.DeliveryStats"> & {
  /**
   * @generated from field: int64 processed = 1;
   */
  processed: bigint;

  /**
   * @generated from field: int64 dropped = 2;
   */
  dropped: bigint;

  /**
   * @generated from field: int64 delivered = 3;
   */
  delivered: bigint;

  /**
   * @generated from field: int64 deferred = 4;
   */
  deferred: bigint;

  /**
   * @generated from field: int64 bounce = 5;
   */
  bounce: bigint;

  /**
   * @generated from field: int64 blocked = 6;
   */
  blocked: bigint;
};

/**
 * Describes the message grpc.api.v1.MarketingCampaign.DeliveryStats.
 * Use `create(MarketingCampaign_DeliveryStatsSchema)` to create a new message.
 */
export const MarketingCampaign_DeliveryStatsSchema: GenMessage<MarketingCampaign_DeliveryStats> = /*@__PURE__*/
  messageDesc(file_marketing_campaign, 0, 2);

/**
 * @generated from message grpc.api.v1.MarketingCampaign.EngagementStats
 */
export type MarketingCampaign_EngagementStats = Message<"grpc.api.v1.MarketingCampaign.EngagementStats"> & {
  /**
   * @generated from field: int64 open = 1;
   */
  open: bigint;

  /**
   * @generated from field: int64 unique_open = 2;
   */
  uniqueOpen: bigint;

  /**
   * @generated from field: int64 click = 3;
   */
  click: bigint;

  /**
   * @generated from field: int64 unique_click = 4;
   */
  uniqueClick: bigint;

  /**
   * @generated from field: int64 spam = 5;
   */
  spam: bigint;

  /**
   * @generated from field: int64 unsubscribe = 6;
   */
  unsubscribe: bigint;

  /**
   * @generated from field: int64 group_unsubscribe = 7;
   */
  groupUnsubscribe: bigint;

  /**
   * @generated from field: int64 group_resubscribe = 8;
   */
  groupResubscribe: bigint;

  /**
   * @generated from field: int64 widget_open = 9;
   */
  widgetOpen: bigint;

  /**
   * @generated from field: int64 unique_widget_open = 10;
   */
  uniqueWidgetOpen: bigint;

  /**
   * @generated from field: int64 widget_reservation = 11;
   */
  widgetReservation: bigint;

  /**
   * @generated from field: int64 unique_widget_reservation = 12;
   */
  uniqueWidgetReservation: bigint;

  /**
   * @generated from field: int64 widget_unsubscribe = 13;
   */
  widgetUnsubscribe: bigint;
};

/**
 * Describes the message grpc.api.v1.MarketingCampaign.EngagementStats.
 * Use `create(MarketingCampaign_EngagementStatsSchema)` to create a new message.
 */
export const MarketingCampaign_EngagementStatsSchema: GenMessage<MarketingCampaign_EngagementStats> = /*@__PURE__*/
  messageDesc(file_marketing_campaign, 0, 3);

/**
 * @generated from message grpc.api.v1.MarketingCampaign.ConversionStats
 */
export type MarketingCampaign_ConversionStats = Message<"grpc.api.v1.MarketingCampaign.ConversionStats"> & {
  /**
   * @generated from field: int64 all = 1;
   */
  all: bigint;

  /**
   * @generated from field: int64 imminent = 2;
   */
  imminent: bigint;

  /**
   * @generated from field: int64 unique_all = 3;
   */
  uniqueAll: bigint;

  /**
   * @generated from field: int64 unique_imminent = 4;
   */
  uniqueImminent: bigint;

  /**
   * @generated from field: int64 guests_all = 5;
   */
  guestsAll: bigint;

  /**
   * @generated from field: int64 guests_imminent = 6;
   */
  guestsImminent: bigint;
};

/**
 * Describes the message grpc.api.v1.MarketingCampaign.ConversionStats.
 * Use `create(MarketingCampaign_ConversionStatsSchema)` to create a new message.
 */
export const MarketingCampaign_ConversionStatsSchema: GenMessage<MarketingCampaign_ConversionStats> = /*@__PURE__*/
  messageDesc(file_marketing_campaign, 0, 4);

/**
 * @generated from enum grpc.api.v1.MarketingCampaign.Status
 */
export enum MarketingCampaign_Status {
  /**
   * @generated from enum value: STATUS_NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: STATUS_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * @generated from enum value: STATUS_SCHEDULED = 2;
   */
  SCHEDULED = 2,

  /**
   * @generated from enum value: STATUS_PROCESSING = 3;
   */
  PROCESSING = 3,

  /**
   * @generated from enum value: STATUS_SENT = 4;
   */
  SENT = 4,

  /**
   * @generated from enum value: STATUS_ABANDONED = 5;
   */
  ABANDONED = 5,

  /**
   * @generated from enum value: STATUS_FAILURE = 6;
   */
  FAILURE = 6,
}

/**
 * Describes the enum grpc.api.v1.MarketingCampaign.Status.
 */
export const MarketingCampaign_StatusSchema: GenEnum<MarketingCampaign_Status> = /*@__PURE__*/
  enumDesc(file_marketing_campaign, 0, 0);

